<template>
  <b-card no-body class="p-3" border-variant="primary">
    <strong>Link is not regular format</strong>
    <a :href="link" target="_blank" rel="noopener noreferrer" class="text-danger" >{{ link }}</a>
    <div class="mt-2 text-right">
      <b-button size="sm" variant="primary" @click="$emit('suggestLinkAgain')"
        >Resolve Again</b-button
      >
    </div>
  </b-card>
</template>

<script>
import { string } from "@amcharts/amcharts4/core"

export default {
  name: "NotInRegularFormatLink",
  props: {
    link: {
      type: string,
      default: () => ""
    }
  }
}
</script>

<style></style>
